<template>
  <div>
    <v-select :items="[0, 6, 12, 18, 24, 30]" :value="value.value" @input="emitValue('value', $event)" :rules="requiredRules" />
    <v-textarea label="Give us the reason for changing the frequency" :value="value.reason" @input="emitValue('reason', $event)" />
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      requiredRules: [v => !!v || v === false || v == 0 || 'Field is required'],
    }
  },
  methods: {
    emitValue(prop, value) {
      this.$emit('input', {
        ...this.value,
        [prop]: value,
      });
    },
  },
}
</script>